<template>
  <div class="row">
    <div class="col-12 col-md-8 offset-md-2 text-left">
      <p class="mt-3">{{ $t('message.card.lookup_intro') }}</p>
      <div class="form-group">
        <label for="card-lookup-rental-no">{{ $t('レンタルNo.') }}</label>
        <input id="card-lookup-rental-no" type="text" class="form-control" v-model="rentalNo"
               placeholder="V2026121000001" autocomplete="off" data-testid="card_lookup_rental_no">
      </div>
      <div class="form-group">
        <label for="card-lookup-email">{{ $t('message.card.lookup_email') }}</label>
        <input id="card-lookup-email" type="email" class="form-control" v-model="email" autocomplete="email" data-testid="card_lookup_email">
      </div>
      <div class="text-danger" role="alert" v-if="error" data-testid="card_lookup_error">{{ $t(error) }}</div>
      <button type="button" class="btn btn-primary btn-lg btn-3d btn-sm-100 mt-2" data-testid="card_lookup_submit"
              :disabled="busy || !rentalNo || !email" @click="submit">
        {{ $t('message.card.lookup_submit') }} <i class="fas fa-arrow-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
// #226 申込済の方の入口。レンタル番号＋メールで予約を特定し url_hash を親に返す。
import axios from 'axios'

export default {
  name: 'CardLookup',
  data () {
    return { rentalNo: '', email: '', busy: false, error: '' }
  },
  methods: {
    async submit () {
      if (this.busy) return
      this.busy = true
      this.error = ''
      try {
        const url = this.$root.baseURL + 'square_card_lookup.json'
        const response = await axios.post(url, { rental_no: this.rentalNo, email: this.email },
          { headers: { 'Content-Type': 'application/json' }, responseType: 'json', timeout: 20000 })
        if (response.data && response.data.ok && response.data.url_hash) {
          this.$emit('found', response.data.url_hash)
        } else {
          this.error = 'message.card.lookup_not_found'
        }
      } catch (e) {
        // 404 も通信エラーも同じ文言（存在有無を漏らさない）
        this.error = 'message.card.lookup_not_found'
      } finally {
        this.busy = false
      }
    }
  }
}
</script>
